<template>
  <div class="page-container orders-list">
    <div class="page-title-container">
      <h1 class="page-title">Pedidos</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>

                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold mr-0"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Descargar"
                @click="downloadReport()"
              >
                <i class="ri-download-2-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre de cliente o ID pedido"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>ID Pedido</span>
            </div>
            <div>
              <span>Nombre del cliente</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.correlationId }}</span>
                </div>

                <div>
                  <span>{{
                    `${o.customerFirstName} ${o.customerLastName}`
                  }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'order-details', params: { id: o.id } }"
                >
                  Ver datos
                </router-link>

                <a
                  href=""
                  class="ml-2"
                  @click.prevent="openChangeStatus(o)"
                  v-if="showModalOrderStatus(o)"
                  >Cambiar estado</a
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de pedido:</span
                    >
                    <span
                      class="d-inline-block ml-1"
                      v-localDate="o.createdAt"
                    ></span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de entrega:</span
                    >
                    <span
                      class="d-inline-block ml-1"
                      v-localDate="o.deliverDate"
                      v-if="o.deliverDate"
                    ></span>
                    <span v-else>-</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Método de envío:</span
                    >
                    <span class="d-inline-block ml-1">{{
                      getDeliveryType(o.deliveryType)
                    }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Método de pago:</span
                    >
                    <span class="d-inline-block ml-1">{{
                      getPaymentLabel(o.paymentMethodId)
                    }}</span>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Importe:</span
                    >
                    <span
                      class="d-inline-block ml-1"
                      v-decimal:pen="o.totalPlusDelivery"
                    ></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span
                      class="d-inline-block ml-1"
                      :class="`badge ${getStatus(o.status).color}`"
                      >{{ getStatus(o.status).label }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th class="px-3">ID Pedido</th>
              <th class="px-3">Fecha de pedido</th>
              <th class="px-3">
                Fecha <br />
                de entrega
              </th>
              <th class="px-3">Nombre del cliente</th>
              <th class="px-3">
                Método <br />
                de envío
              </th>
              <th class="px-3">
                Método <br />
                de pago
              </th>
              <th class="px-3">Importe</th>
              <!-- <th>
                Dirección <br />
                confirmada
              </th> -->
              <!-- <th>ERP ID</th> -->
              <th class="px-3">Estado</th>
              <th class="px-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">
                <span>{{ o.correlationId }}</span>
              </td>
              <td class="text-center">
                <span v-localDate="o.createdAt"></span>
              </td>
              <td class="text-center">
                <span v-localDate="o.deliverDate"></span>
              </td>
              <td class="pl-md-4">
                {{ `${o.customerFirstName} ${o.customerLastName}` }}
              </td>
              <td class="text-center text-uppercase">
                <span>{{ getDeliveryType(o.deliveryType) }}</span>
              </td>
              <td class="text-center text-uppercase">
                <span>{{ getPaymentLabel(o.paymentMethodId) }}</span>
              </td>
              <td class="text-center" v-decimal:pen="o.totalPlusDelivery"></td>
              <!-- <td class="text-center">{{ o.confirmedAddress }}</td> -->
              <!-- <td class="text-center">{{ o.erpId }}</td> -->
              <td class="text-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>

              <td class="text-center d_option pr-md-4">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Ver datos"
                      :to="{ name: 'order-details', params: { id: o.id } }"
                    />
                    <DropdownItem
                      text="Cambiar estado"
                      @click="openChangeStatus(o)"
                      v-if="showModalOrderStatus(o)"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <ModalOrderStatus
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :selectedOption="selectedOption"
      @updated="updateStatus"
      v-if="selectedOption"
    />
  </div>
</template>

<script>
import {
  Alert,
  ConfirmationModalMixin,
  Constants,
  DropdownItem,
  DropdownTable,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  Util,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import fileDownload from "js-file-download";

import { OrderService } from "@/core/services";

import ModalOrderStatus from "../Components/ModalOrderStatus";

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ModalOrderStatus
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      list: [],
      tooltipType: null,
      selectedOption: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.OrdersStatus.PENDING,
            LocalConstants.OrdersStatus.PAYMENT_CONFIRMED,
            LocalConstants.OrdersStatus.DELIVERED,
            LocalConstants.OrdersStatus.CANCELLED,
            LocalConstants.OrdersStatus.REJECTED,
          ],
        },
        {
          label: "Método de pago",
          key: "paymentMethodIds",
          type: Constants.TypeFilters.MULTIPLE,
          options: [],
        },
        {
          label: "Fecha de pedido",
          key: "createdAt",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
        {
          label: "Fecha de entrega",
          key: "deliverAt",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          search: this.search,
          ...this.filters,
        };
        const response = await OrderService.list(params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getIdentifierType(key) {
      return Util.searchValue(key, Constants.IdentifierType);
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.OrdersStatus);
    },
    getPaymentLabel(id) {
      let label = "";

      let item = this.filterOptions[1].options.find((o) => o.key == id);

      if (item) {
        label = item.label;
      }

      return label;
    },
    async changeStatus() {},
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado del pedido?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    async setPaymentMethods() {
      this.filterOptions[1].options = Object.values(
        LocalConstants.PaymentMethods
      );
    },
    updateStatus({ id, status }) {
      let item = this.list.find((i) => i.id == id);

      if (item) {
        item.status = status;
      }
    },
    getDeliveryType(key) {
      let type = "-";

      if (key) {
        type = Util.searchValue(key, LocalConstants.ShippingTypes).label;
      }

      return type;
    },
    showModalOrderStatus(order) {
      let status = true;

      if (
        order.status == LocalConstants.OrdersStatus.CANCELLED.key ||
        order.status == LocalConstants.OrdersStatus.REJECTED.key
      ) {
        status = false;
      }

      return status;
    },
    async downloadOrders() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          search: this.search,
          ...this.filters,
        };
        const response = await OrderService.downloadOrderList(params);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  computed: {
    showFiltersList() {
      return Object.keys(this.filters).length >= 1;
    },
  },
  async mounted() {
    await this.loadData();

    // Asignar métodos de pago activos para filtro
    this.setPaymentMethods();
  },
};
</script>

<style lang="stylus"></style>
